import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.number.constructor.js";
import { getListByID } from "@/api/config";
export default {
  name: "checkInfo",
  props: {
    ID: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      formData: {}
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getListByID({
                formId: _this.ID
              });
            case 2:
              res = _context.sent;
              _this.formData = res.data.formConfig;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    headStyle: function headStyle() {
      var styleJson = {};
      styleJson = {
        color: "#409EFF"
      };
      return styleJson;
    },
    rowStyle: function rowStyle() {
      var styleJson = {};
      styleJson = {
        color: "#000",
        backgroundColor: "#ECF8FF"
      };
      return styleJson;
    }
  }
};